export interface CurrentInventoryPackScopeItem {
  game_id: string;
  pack_id: string;
}

export const normalizeCurrentInventoryPackValue = (value: string | number | null | undefined) => {
  const text = String(value ?? '').trim();
  const digits = text.replace(/\D/g, '');
  return (digits || text).replace(/^0+(?=\d)/, '');
};

export const getCurrentInventoryPackScopeKey = (gameId: string | number, packId: string | number) =>
  `${normalizeCurrentInventoryPackValue(gameId)}:${normalizeCurrentInventoryPackValue(packId)}`;


